export const VERSION = '2.8.24'

export const ACTIONS = {
    UPDATE: 'UPDATE',
    FORCE_UPDATE: 'FORCE_UPDATE',
    LOAD_JSON: 'LOAD_JSON',
    START_OVER: 'START_OVER',
  };
export const DEFAULT_STATE_VALUE = '-1'
export const ENGRAVING_TIMEOUT = 1000
export const DEFAULT_STONE = 'd2'
export const INITIAL_STATE = {
  'version':VERSION,
  'showSticky':true,
  'active_view':1
}
export const SPECIAL_NOTE_ACTIVATE = true
export const SPECIAL_NOTE = ""
//export const SPECIAL_NOTE ='Order by Thursday, December 11, 2025 for Christmas delivery. This delivery date overrides regular processing times.'
//export const SPECIAL_NOTE = "Order by Sunday, February 1, 2026 for Valentine's Day delivery. This delivery date overrides regular processing times. "
//export const SPECIAL_NOTE = "Order by Thursday, April 24, 2025 for Mother's Day delivery. This delivery date overrides regular processing times. "
//export const SPECIAL_NOTE ="Order by Monday, June 5, 2023 for Father's Day delivery. This delivery date overrides regular processing times."

export const MSG_NO_SESSION1 = 'Site error. Please return to '
export const MSG_NO_SESSION2 = ', personalize, and add to cart again. If problem persists, please contact customer service. We’re sorry for the inconvenience.'
export const MSG_NOT_READY_ADD_TO_CART ='Please select all options in order to add product to the shopping bag'
export const MSG_NO_SKU = "We cannot complete your selection as specified. Please contact customer service for further assistance. We’re sorry for the inconvenience."
export const PRICE_URL = 'https://test.thepersonalizedbest.com/charmprice/'
export const PRICE_URL_PROD = 'https://main.thepersonalizedbest.com/charmprice/'
export const JSON_URL = 'https://test.thepersonalizedbest.com/json6.json/'
//export const JSON_URL = 'http://main-master.thepersonalizedbest.com/json6.json/'
export const JSON_URL_PROD = 'https://main.thepersonalizedbest.com/json6.json/'
export const UPDATE_QSKU_URL = 'https://us.thepersonalizedbest.com/makeqsku2/?'
export const ADD_TO_CART_URL = 'https://test.thepersonalizedbest.com/pers_add_to_cart6'
export const ADD_TO_CART_URL_CHARM = 'https://main.thepersonalizedbest.com/charm_pers_add_to_cart6'
//export const ADD_TO_CART_URL = 'http://main-master.thepersonalizedbest.com/pers_add_to_cart6'
export const ADD_TO_CART_URL_PROD = 'https://main.thepersonalizedbest.com/pers_add_to_cart6'
export const ADD_TO_CART_URL_PROD_CHARM = 'https://main.thepersonalizedbest.com/charm_pers_add_to_cart6'
//export const ADD_TO_CART_URL_PROD_CHARM = 'http://52.21.230.12/charm_pers_add_to_cart6'
export const OPTION_URL = '//static.thepersonalizedbest.com/pers4/'
export const IMAGE_URL_PROD = '//images.thepersonalizedbest.com/engrave.jpg/'
export const IMAGE_URL = '//us.thepersonalizedbest.com/engrave.jpg/'
export const DEFAULT_CFG = 'CFG12553000000000'
export const ALL_STONES = ['c','s1','s2','s3','s4','s5','s6','s7','s8','s9','s10','a1','a2','a3','a4','a5','a6','a7','a8','a9','a10']
export const CHARM_9000 ={
  "1":['9329','9355'],
  "2":['4916','4917'],
  //"3":['4878','4871','4873','4865','4887','4872','4879','4858','4867','4877','4868','4869','4866','4888','4859','4870','4876','4885'],
  "3":['4878','4871','4873','4865','4887','4872','4879','4858','4867','4877','4868','4869','4866','4888','4870','6282','6487'],
  //"4":['4860','4861','4883','4875','4880','4881','4882','4874','4884','4915','4886'],
  "4":['4860','4861','4883','4874','4884','6284'],
  //"4":['4860','4861','4883','4875','4881','4874','4884','4886','6284'],
  "5":['4862','4863','4967','4968','4969','4970','4971','4972','4973','4974','4975','4976','4977','4978'],
  "11":['6394','6395','6396','6997']
  //,
  //"12":['6476','6477','6478','6479','6480','6481','6482','6483','6484','6485','6486']
  
}
export const CHARM_ZSKU ={"20485294":"4858",
"20485295":"4860",
"20485296":"4861",
"20485297":"4862",
"20485298":"4865",
"20485299":"4866",
"20485300":"4867",
"20485301":"4868",
"20485302":"4869",
"20485303":"4870",
"20485304":"4871",
"20485305":"4872",
"20485306":"4873",
"20485307":"4874",
"20485308":"4875",
"20485309":"4877",
"20485310":"4878",
"20485311":"4879",
"20485312":"4881",
"20485313":"4883",
"20485314":"4884",
"20485315":"4885",
"20485316":"4886",
"20485317":"4887",
"20485318":"4888",
"20485319":"4916",
"20485320":"4917",
"20485321":"4967",
"20485322":"4968",
"20485323":"4969",
"20485324":"4970",
"20485325":"4971",
"20485326":"4972",
"20485327":"4973",
"20485328":"4974",
"20485329":"4975",
"20485330":"4976",
"20485331":"4977",
"20485332":"4978",
"20485333":"6282",
"20485334":"6284",
"20485335":"6394",
"20485336":"6395",
"20485337":"6396",
"20485338":"6476",
"20485339":"6487",
"20485340":"9000",
"20485341":"9300",
"20485342":"9329",
"20485343":"9355"}
export const START_OVER_STATE = {
  'active_view':1,
  c:   DEFAULT_STATE_VALUE,
  d:  DEFAULT_STATE_VALUE,
  i:  DEFAULT_STATE_VALUE,
  sc:  DEFAULT_STATE_VALUE,
  s1:  DEFAULT_STATE_VALUE,
  s2:  DEFAULT_STATE_VALUE,
  s3:  DEFAULT_STATE_VALUE,
  s4:  DEFAULT_STATE_VALUE,
  s5:  DEFAULT_STATE_VALUE,
  s6:  DEFAULT_STATE_VALUE,
  s7:  DEFAULT_STATE_VALUE,
  s8:  DEFAULT_STATE_VALUE,
  s9:  DEFAULT_STATE_VALUE,
  s10: DEFAULT_STATE_VALUE,
  a1:  DEFAULT_STATE_VALUE,
  a2:  DEFAULT_STATE_VALUE,
  a3:  DEFAULT_STATE_VALUE,
  a4:  DEFAULT_STATE_VALUE,
  a5:  DEFAULT_STATE_VALUE,
  a6:  DEFAULT_STATE_VALUE,
  a7:  DEFAULT_STATE_VALUE,
  a8:  DEFAULT_STATE_VALUE,
  a9:  DEFAULT_STATE_VALUE,
  a10:  DEFAULT_STATE_VALUE,
  m:   DEFAULT_STATE_VALUE,
  f:   "0",
  rs:  DEFAULT_STATE_VALUE,
  bl:  DEFAULT_STATE_VALUE,
  bl2:  DEFAULT_STATE_VALUE,
  cl:  DEFAULT_STATE_VALUE,
  cl2:  DEFAULT_STATE_VALUE,
  e1:  "",
  e2:  "",
  e3:  "",
  e4:  "",
  e5:  "",
  e6:  "",
  e7:  "",
  e8:  "",
  altered: false
 
}



// WEBPACK FOOTER //
// ./src/constants.js